import { w3cwebsocket as W3CWebSocket } from "websocket";
import { getAccessTokenFromCookie } from "./authentication";
import { WEBSOCKET_CLOSE_REASON_CHANGING_STATIONS, WEBSOCKET_CLOSE_REASON_LOGGING_OUT, WS_CLIENT_NORMAL_CLOSURE_CODE } from "./constants";

let client = null;
let clientStation = "";
let connectInterval;

export function getWebSocketClient(eid, isAdmin, station) {
  if (isClientActive(client) && !isStationChanged(station)) {
    console.log("Returning cached client connection with eid: ", eid);
    return client;
  } else {
    if (isClientStale(client)) {
      console.warn("Client is closing/closed, reopening connection...", client);
    }
    if (isStationChanged(client) && isClientActive(client)) {
      client.close(WS_CLIENT_NORMAL_CLOSURE_CODE, WEBSOCKET_CLOSE_REASON_CHANGING_STATIONS);
      clientStation = "";
    }
    console.log("Creating new client connection with eid: ", eid);
    if (isStationGiven(station)) {
      client = new W3CWebSocket(
        process.env.REACT_APP_WEBSOCKET_API +
          "?employeeId=" +
          eid +
          "&isAdmin=" +
          isAdmin +
          "&station=" +
          station +
          "&token=" +
          getAccessTokenFromCookie()
      );
      clientStation = station;
    } else {
      client = new W3CWebSocket(
        process.env.REACT_APP_WEBSOCKET_API +
          "?employeeId=" +
          eid +
          "&isAdmin=" +
          isAdmin +
          "&token=" +
          getAccessTokenFromCookie()
      );
    }
    client.onopen = () => {
      console.log("WebSocket Client Connected");
      clearTimeoutInterval();
    };
    console.log(client);
    return client;
  }
}

export function disconnect() {
  if (client) {
    console.log("Disconnecting websocket connection...");
    client.close(WS_CLIENT_NORMAL_CLOSURE_CODE, WEBSOCKET_CLOSE_REASON_LOGGING_OUT);
    client = null;
    clientStation = "";
  }
}

export function setConnectInterval(interval) {
  console.log("Setting connection interval...");
  connectInterval = interval;
}

export function clearTimeoutInterval() {
  clearTimeout(connectInterval);
  connectInterval = null;
}

function isClientActive(client) {
  return client && client.readyState < 2;
}

function isClientStale(client) {
  return client && client.readyState >= 2;
}

function isStationChanged(station) {
  return isStationGiven(station) && station !== clientStation;
}

function isStationGiven(station) {
  return station !== undefined && station !== "" && station !== null;
}
